/* eslint-disable import/max-dependencies */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTableSelections, type DataItem } from "@fas/ui-framework";
import {
  SimpleTableActionButton,
  ConfirmTableActionButton,
  TableActions,
  TableActionGroup,
} from "@fas/ui-core";
import { Edit, Delete } from "@mui/icons-material";
import externalRedirect from "../../helpers/ExternalRedirect";
import { LINKING_LIST } from "../../helpers/constants";
import Can from "../Can";
import {
  bulkDeleteLinkingInfoSaga,
} from "../../actions/linkingList";
import { getHashValue } from "../../services/jusCan";
import type { State } from "../../pages/AppStoreWrapper";

const handleEdit = (id: string) => {
  externalRedirect({ to: `/linking/edit/${id}?hashId=${getHashValue()}`, target: "_blank" });
};

function ActionsMenu() {
  const items = useSelector(
    (state: State): Array<DataItem> => getTableSelections(state, LINKING_LIST)
  );
  const dispatch = useDispatch();
  const handleDelete = () => {
    dispatch(bulkDeleteLinkingInfoSaga());
  };

  return (
    <TableActions>
      <TableActionGroup>
        <Can permissions={["linking.update"]}>
          <SimpleTableActionButton
            tooltip="Edit"
            disabled={items.length > 1}
            onClick={() => handleEdit(items[0]?.id)}
            Icon={<Edit />}
          />
        </Can>
        <Can permissions={["linking.remove"]}>
          <ConfirmTableActionButton
            tooltip="Delete"
            viewPath="delete"
            items={items}
            onClick={() => handleDelete()}
            Icon={<Delete />}
            confirmTitle="Delete items "
            confirmText="Are you sure you want to delete "
          />
        </Can>
      </TableActionGroup>
    </TableActions>
  );
}

export default ActionsMenu;
